import React, { useState } from 'react';
import BelvoirAdminLoginLayout from './BelvoirAdminLoginLayout';

const PRODUCT_SLIDES = [
  {
    label: 'Daily list',
    headline: 'See every Dog Park booking for the day — names, times, and extra dogs at a glance.',
  },
  {
    label: 'Gate codes',
    headline: 'Set the padlock code for each date or time window. Staff print the list and use that code.',
  },
  {
    label: 'Print sheets',
    headline: 'A clear, printable day sheet for the gate — who is booked and how many dogs they are bringing.',
  },
];

const DogParkLogin = ({ onSuccess }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch('https://api.belvoircastle.com/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem('token', data.token);
        localStorage.setItem('user', JSON.stringify(data.user));
        if (onSuccess) onSuccess();
      } else {
        setError(data.message || 'Login failed');
        setLoading(false);
      }
    } catch (err) {
      setError('Login failed. Please try again.');
      setLoading(false);
    }
  };

  return (
    <BelvoirAdminLoginLayout
      productLabel="Dog Park Bookings"
      credentialsHint="Use your Belvoir Data Centre credentials."
      slides={PRODUCT_SLIDES}
      showcaseFooter="Belvoir Castle Dog Park"
      email={email}
      password={password}
      error={error}
      loading={loading}
      onEmailChange={(e) => setEmail(e.target.value)}
      onPasswordChange={(e) => setPassword(e.target.value)}
      onSubmit={handleSubmit}
      emailId="dog-park-email"
      passwordId="dog-park-password"
    />
  );
};

export default DogParkLogin;
